import React, { Component } from "react";
import {Form, Input, Button, Checkbox, message, Alert, Select, Typography} from "antd";
import axios from "axios";
import {FileProtectOutlined} from "@ant-design/icons";
import { API_URI } from "../../constant/Config";
import {t} from '../../constant/i18n';
import {THEME} from '../../constant/theme';

const { Option } = Select;
const { Text, Link } = Typography;

class CommandesPassportForm extends Component {
    state = {
        isFormVisible: false,
        dataCmd: this.props.dataCmd,
        isSubmitted: false,
    };

    toggleFormVisibility = () => {
        this.setState({ isFormVisible: !this.state.isFormVisible });
    };

    handleFinish = async (values) => {
        const response = await axios.post(
            `${API_URI}/api_member/passport-benevolat-add`,
            values,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        if (response.status === 200) {
            this.setState({ isSubmitted: true });
            message.success(t('passport.formSent'));
        } else {
            message.error(t('passport.formError'));
        }
    };

    handleFinishFailed = () => {
        message.error(t('passport.fillAllFields'));
    };

    render() {
        const { dataCmd, isFormVisible, isSubmitted } = this.state;
        const passportData = dataCmd?.passport_benevolat?.data;

        // Commande de passport non authorisé car il faut que le membre est déjà versé le premier paiement
        if (passportData === false) {
            return null;
        }

        if (passportData !== null) {
            return (
                <Alert
                    message={t('passport.alreadyOrdered')}
                    description={t('passport.alreadyOrderedDesc')}
                    type="info"
                    showIcon
                />
            );
        }

        if (isSubmitted) {
            return (
                <Alert
                    message={t('passport.orderSuccess')}
                    description={t('passport.orderSuccessDesc')}
                    type="success"
                    showIcon
                />
            );
        }

        return (
            <div>
                {!this.state.isFormVisible && (
                    <Alert
                        message={t('passport.getFreeTitle')}
                        description={
                            <div>
                                {t('passport.getFreeDesc')}
                                <br />
                                {t('passport.clickToReceive')}
                                <br /><br />
                                {t('passport.learnMore')}<Link href={THEME.urls.volunteerPassport} target="_blank">{t('passport.volunteerPassport')}</Link>
                                <br /><br />

                                <Button type="primary" onClick={this.toggleFormVisibility}>
                                    <FileProtectOutlined /> {t('passport.orderMyPassport')}
                                </Button>
                            </div>
                        }
                        type="warning"
                        showIcon
                    />
                )}
                {this.state.isFormVisible && (
                    <Alert
                        message={t('passport.orderTitle')}
                        description={
                            <div style={{ marginTop: 20 }}>
                                <Form
                                    ref={(form) => (this.formRef = form)}
                                    name="commandes_passport"
                                    layout="vertical"
                                    onFinish={this.handleFinish}
                                    onFinishFailed={this.handleFinishFailed}
                                    initialValues={{
                                        id_commande: this.state.dataCmd.data.id, // Initialisation avec la valeur de this.state.dataCmd.data.id
                                        pays: "France",
                                    }}
                                >
                                    <Form.Item
                                        label={t('passport.civility')}
                                        name="civ"
                                        rules={[{ required: true, message: t('passport.selectCivility') }]}
                                    >
                                        <Select placeholder={t('passport.selectCivilityPlaceholder')}>
                                            <Option value="M.">{t('profil.mr')}</Option>
                                            <Option value="Mme.">{t('profil.mme')}</Option>
                                        </Select>
                                    </Form.Item>

                                    <Form.Item
                                        label={t('orderTransactions.lastName')}
                                        name="nom"
                                        rules={[{ required: true, message: t('passport.enterName') }]}
                                    >
                                        <Input placeholder={t('orderTransactions.lastName')} />
                                    </Form.Item>

                                    <Form.Item
                                        label={t('orderTransactions.firstName')}
                                        name="prenom"
                                        rules={[{ required: true, message: t('passport.enterFirstName') }]}
                                    >
                                        <Input placeholder={t('orderTransactions.firstName')} />
                                    </Form.Item>

                                    <Form.Item
                                        label={t('passport.phone')}
                                        name="numero"
                                        rules={[{ required: true, message: t('passport.enterPhone') }]}
                                    >
                                        <Input placeholder={t('passport.numberPlaceholder')} />
                                    </Form.Item>

                                    <Form.Item
                                        label={t('passport.streetAndNum')}
                                        name="rue"
                                        rules={[{ required: true, message: t('passport.enterStreet') }]}
                                    >
                                        <Input placeholder={t('passport.street')} />
                                    </Form.Item>

                                    <Form.Item
                                        label={t('passport.postalCode')}
                                        name="cp"
                                        rules={[{ required: true, message: t('passport.enterPostalCode') }]}
                                    >
                                        <Input placeholder={t('passport.postalCode')} />
                                    </Form.Item>

                                    <Form.Item
                                        label={t('orderTransactions.city')}
                                        name="ville"
                                        rules={[{ required: true, message: t('passport.enterCity') }]}
                                    >
                                        <Input placeholder={t('orderTransactions.city')} />
                                    </Form.Item>

                                    <Form.Item
                                        label={t('passport.countryFranceOnly')}
                                        name="pays"
                                        rules={[{ required: true, message: t('passport.selectCountry') }]}
                                    >
                                        <Select placeholder={t('passport.countryPlaceholder')}>
                                            <option value="France">France</option>
                                        </Select>
                                    </Form.Item>

                                    <Form.Item
                                        name="id_commande"
                                    >
                                        <Input type="hidden" />
                                    </Form.Item>

                                    <Form.Item>
                                        <p>
                                            {t('passport.formNotice')}
                                        </p>
                                    </Form.Item>

                                    <Form.Item
                                        name="terms"
                                        valuePropName="checked"
                                        rules={[
                                            {
                                                required: true,
                                                message: t('passport.acceptTerms'),
                                            },
                                        ]}
                                    >
                                        <Checkbox>
                                            {t('passport.acceptDataUse')}
                                        </Checkbox>
                                    </Form.Item>

                                    <Form.Item>
                                        <Button type="primary" htmlType="submit">
                                            {t('passport.validateOrder')}
                                        </Button>
                                    </Form.Item>
                                </Form>
                            </div>
                        }
                        type="warning"
                        showIcon
                    />

                )}
            </div>
        );
    }
}

export default CommandesPassportForm;
